import { CommonAPI } from "../Client";

const buildAnalyticParams = (payload) => {
  const params = new URLSearchParams();
  params.set("page", String(payload?.page ?? 0));
  params.set("size", String(payload?.size ?? 10));
  params.set("sortBy", payload?.sortBy ?? payload?.sortby ?? "");
  params.set("sortDir", payload?.sortDir ?? payload?.sortdir ?? "");

  if (payload?.customerId) {
    params.set("customerId", payload.customerId);
  }

  return params;
};

export const getQrAnalyticApi = async (payload) => {
  try {
    const response = await CommonAPI.get(`/qr/analytic?${buildAnalyticParams(payload).toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postQrAnalyticApi = async (payload) => {
  try {
    const response = await CommonAPI.post(`/qr/analytic`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getArAnalyticApi = async (payload) => {
  try {
    const response = await CommonAPI.get(`/ar/analytic?${buildAnalyticParams(payload).toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postArAnalyticApi = async (payload) => {
  try {
    const response = await CommonAPI.post(`/ar/analytic`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
